var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(_vm.$route.name !='/login')?_c('div',[_c('div',{staticClass:"main-header"},[_c('logo_header'),_c('navbar')],1),_c('sidebar')],1):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }